import { useQuery } from "@tanstack/react-query";
import { submissionsService } from "@/features/submissions/services/submissions.service";

export function usePropertyClassCodesQuery(enabled: boolean = true) {
  return useQuery({
    queryKey: ["property-class-codes-all"],
    queryFn: () => submissionsService.getAllPropertyClassCodes(),
    enabled,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
